<div class="poll-block show" >
    <div class="field-title">
        {{ schema.title }}
    </div>
    <div *ngIf="schema.description" class="field-description">
        {{ schema.description }}
    </div>
    <mat-radio-group [formControl]="control">
        <mat-radio-button [name]="name" *ngFor="let option of schema.items.oneOf" [value]="option.d">
            {{option.d}}
        </mat-radio-button>
    </mat-radio-group>
</div>